import { User } from './User.model';

export class ActivityByUserByCompanyByDateRangeResponse {
    users: Array<User>;

    constructor(activityByUserByCompanyByDateRange: Array<User>) {
        this.users = activityByUserByCompanyByDateRange;
    }
}
